'use client';

import { useCallback, useEffect, useRef, useState } from 'react';
import { Typography } from '@bgzt/ui'; // TODO: @bgzt/ui v1.0.2 릴리즈 후 바꾸기
import clsx from 'clsx';

import globalStyles from '~/styles/utils.module.css';
import styles from './productDescription.module.css';

type Props = {
  defaultShouldMore?: boolean;
  values: {
    description: string;
  };
};

export const ProductDescription = ({ defaultShouldMore, values, ...props }: Props) => {
  const textRef = useRef<HTMLParagraphElement | null>(null);
  const moreTextRef = useRef<HTMLSpanElement | null>(null);
  const [shouldMore, setShouldMore] = useState<boolean | null>(defaultShouldMore ?? null);

  const handleToggleMoreButton = useCallback(() => {
    if (shouldMore === null) return;

    setShouldMore((prev) => !prev);
  }, [shouldMore]);

  useEffect(() => {
    if (!textRef?.current) return;

    if (textRef.current.scrollHeight > textRef.current.clientHeight) {
      setShouldMore(false);
    }
  }, [values]);

  useEffect(() => {
    // 더보기 노출 상황에서
    if (shouldMore === false) {
      if (!textRef?.current || !moreTextRef?.current) return;

      const descriptionfontSize = parseFloat(globalThis.getComputedStyle(textRef?.current).fontSize);

      // 기본 스타일 적용
      if (descriptionfontSize === 16) return;

      const textHeight = descriptionfontSize * 1.5;

      // AOS 디바이스 폰트 수정 시, 동적으로 높이값 더보기 노출 위치 수정
      textRef.current.style.maxHeight = `${textHeight * 20}px`;
      moreTextRef.current.style.bottom = `${(textHeight - descriptionfontSize) / 2 - 1}px`;
    }
  }, [shouldMore]);

  return (
    <Typography
      as="p"
      variant="B1"
      color="gray-900"
      style={{
        maxHeight: shouldMore ? '100%' : '480px',
        overflowY: shouldMore ? 'visible' : 'hidden',
      }}
      className={styles['description']}
      ref={textRef}
      {...props}
    >
      {values['description']}

      {shouldMore === false && (
        <Typography
          as="span"
          variant="L5"
          color="gray-500"
          className={clsx([styles['moreButton'], styles['gradient']])}
          ref={moreTextRef}
        >
          ...
          <span className={clsx(globalStyles['linkText'])} onClick={handleToggleMoreButton}>
            더보기
          </span>
        </Typography>
      )}
    </Typography>
  );
};
